export default "__VITE_ASSET__CC7I8RMo__"